<div class="section">
  <div class="section__head">
    <span class="section__eyebrow">Departments<span class="sgl-arrows" aria-hidden="true"></span></span>
    <span class="section__spacer"></span>
    <button type="button" class="m-btn m-btn-secondary section__add-btn" (click)="addOpen = !addOpen">
      <mat-icon>add</mat-icon>
      Add department
    </button>
  </div>

  @if (addOpen) {
    <div class="section__add-panel">
      <input
        class="section__add-search"
        type="text"
        [formControl]="searchControl"
        placeholder="Search departments not yet assigned…" />

      <div class="section__add-results">
        @for (contact of filteredContacts$ | async; track trackByContactId($index, contact)) {
          <button type="button" class="section__sugg" (click)="selectContact(contact)">
            @if (contact.productId !== null && productsById.get(contact.productId); as product) {
              <span class="section__sugg-product-avatar">
                <img [ngSrc]="product | transportModeIcon" width="16" height="16" alt="" />
              </span>
            } @else {
              <app-avatar
                [displayName]="contact.displayName"
                [photoUrl]="contact.photoUrl"
                [size]="28"
                color="var(--sgl-avatar-department)"
                textColor="var(--sgl-avatar-department-text)"></app-avatar>
            }
            <span class="section__sugg-text">
              <span class="section__sugg-name">{{ contact.displayName }}</span>
              <span class="section__sugg-sub">{{ contact.description }}</span>
            </span>
            <mat-icon class="section__sugg-plus">add</mat-icon>
          </button>
        } @empty {
          <div class="section__add-empty">No unassigned departments match.</div>
        }
      </div>

      <button type="button" class="section__create-new" (click)="createNewContact()">
        <mat-icon>add_circle</mat-icon>
        Create a new department…
      </button>
    </div>
  }

  @if (departments.length) {
    <div class="section__list" cdkDropList (cdkDropListDropped)="drop($event)">
      @for (department of departments; track trackByAssignmentId($index, department); let i = $index) {
        <div class="orow" cdkDrag cdkDragBoundary=".section__list">
          <mat-icon class="orow__handle">drag_indicator</mat-icon>
          <span class="orow__position">{{ i + 1 }}</span>
          @if (department.product) {
            <span class="orow__product-avatar">
              <img [ngSrc]="department.product | transportModeIcon" width="18" height="18" alt="" />
            </span>
          } @else {
            <app-avatar
              [displayName]="department.displayName"
              [size]="32"
              color="var(--sgl-avatar-department)"
              textColor="var(--sgl-avatar-department-text)"></app-avatar>
          }

          <div class="orow__info">
            <div class="orow__row1">
              <span class="orow__name">{{ department.displayName }}</span>
              <span class="orow__tag"><mat-icon>apartment</mat-icon>Department</span>
              <app-is-active [isActive]="department.isActive"></app-is-active>
            </div>
            @if (department.description) {
              <p class="orow__description">{{ department.description }}</p>
            }
          </div>

          <button
            type="button"
            class="orow__remove"
            [attr.aria-label]="'Remove ' + department.displayName"
            title="Remove from this organisation"
            (click)="remove.emit(department.contactId)">
            <mat-icon>close</mat-icon>
          </button>
          <div class="orow__placeholder" *cdkDragPlaceholder></div>
        </div>
      }
    </div>
  } @else {
    <p class="section__empty">No departments assigned to this organisation.</p>
  }
</div>
